import useSWR from 'swr';
import { dataTrpc } from '../config/trpc';

export function usePublicBusDataInBounds({
  siteId,
  bounds,
}: {
  siteId?: string;
  bounds?: google.maps.LatLngBoundsLiteral;
}) {
  const { data, error, isValidating } = useSWR(
    siteId && bounds
      ? {
          keyName: 'usePublicBusData',
          siteId,
          bounds,
        }
      : null,
    async (params) =>
      dataTrpc.publicTransport.getBusStopsAndRoutesByLocation.query({
        siteId: params.siteId!,
        bounds: {
          minLat: params.bounds!.south,
          maxLat: params.bounds!.north,
          minLng: params.bounds!.west,
          maxLng: params.bounds!.east,
        },
      })
  );

  return {
    data,
    isValidating,
    error,
  };
}
